import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

// New look: matches Billing History's card and table (payment.styles sectionContainer/tableRow/tableCell and the
// sort-label headers), with header text at full strength instead of Billing History's 60% opacity, for contrast.
const styles = (theme) => ({
  card: reskinStyles(theme, { ...theme.cardStyles.outlined, padding: theme.spacing(4, 8) }),
  headerCell: reskinStyles(theme, {
    borderBottom: 0,
    color: theme.colors.text_secondary,
    fontSize: 10,
    lineHeight: '14px',
    textTransform: 'uppercase'
  }),
  row: reskinStyles(theme, { height: 47 }),
  cell: reskinStyles(theme, {
    color: theme.colors.light_text,
    fontSize: 14,
    overflowWrap: 'anywhere'
  })
});

export default makeStyles(styles);
